$height: 100%;

.carousel-container {
    overflow: hidden;
    position: relative;
    height: 100%;

    .carousel-container-inner {
        position: relative;
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        width: 100%;
        height: 100%;
        display: flex;
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    // TODO: do we need this
    .carousel-full-width {
        width: 100%;
        flex: 0 0 100%;
    }

    .carousel-cell {
        min-height: 100%;
    }

    &:focus {
        outline: 0;
    }

    // TODO: clean up here
    .carousel-nav-button {
        position: absolute;
        z-index: 3;
        top: 50%;
        width: 40px;
        height: 40px;
        border: 1px solid gray('light');
        border-radius: 50%;
        background: $white;
        cursor: pointer;
        transform: translateY(-50%);

        filter: alpha(opacity=80);
        opacity: 0.80;

        &:hover {
            background: $white;
            filter: alpha(opacity=100);
            opacity: 1;
        }

        &:disabled {
            visibility: hidden;
        }

        &:focus {
            outline: 0;
        }

        &:active {
            filter: alpha(opacity=60);
            opacity: 0.6;
        }

        &.previous {
            left: 10px;
        }

        &.next {
            right: 10px;
        }

        svg {
            position: absolute;
            left: 20%;
            top: 20%;
            width: 60%;
            height: 60%;
        }

        .arrow {
            fill: gray('base');
        }

        .no-svg {
            color: gray('base');
            font-size: 26px;
        }
    }
}